// ==============================|| 資料請求で配布するダウンロード資料 ||============================== //
//
// 配布するのは営業で使っている「OHANA AI サービス紹介資料」の1点のみ。
// PDF の実体は my-app/public/documents/ に配置しており、ビルド時にそのまま静的配信される。
// 資料を差し替えるときは、同じパスに上書きしたうえで
// my-app/src/assets/images/doc-service-1〜3.png のサムネイル(1・3・7ページ目)も作り直すこと。
//
// 資料を複数配布する構成に戻す場合は、この配列に追加すれば
// フォーム(DocumentRequestForm)と紹介欄(DocumentRequestTop)の両方が自動で複数表示に切り替わる。

export type LeadDocument = {
  id: string;
  title: string;
  /** タイトルの下に出す一行説明。内容は資料本体と一致させる */
  description: string;
  /** public 配下のパス */
  file: string;
  /** ダウンロード時のファイル名(日本語で保存させる) */
  downloadName: string;
  volume: string;
};

export const LEAD_DOCUMENTS: LeadDocument[] = [
  {
    id: 'service-guide',
    title: 'OHANA AI サービス紹介資料',
    description:
      'AIアセスメントから個別支援計画書の自動作成まで、専門的支援加算のシミュレーション、減算対策、料金と導入の流れ',
    file: '/documents/ohana-ai-service-guide.pdf',
    downloadName: 'OHANA_AI_サービス紹介資料.pdf',
    volume: '全17ページ'
  }
];

// ==============================|| リード(資料請求者)の通知先 ||============================== //
//
// このサイトは S3 + CloudFront の静的配信でサーバーを持たないため、
// フォーム送信を受け取る口として自社AWS内に Lambda を1つ立てている。
//   実体: aws/terraform/lead_form.tf / aws/terraform/functions/lead-notify/
//   経路: ブラウザ --POST--> Lambda Function URL --> SES --> 社内の通知先アドレス
//
// 外部のフォーム受信サービスを使わないのは、請求者(福祉事業者)の氏名・電話番号を
// 社外のサーバーに経由させないため。
//
// 【設定手順】aws/terraform で terraform apply したあと、
//   terraform output -raw lead_form_endpoint
// で表示される URL を下の LEAD_ENDPOINT に貼る。
//
// 空文字のままの場合はメールソフトの下書き(mailto)を開くフォールバックが動くが、
// 訪問者自身が送信ボタンを押さないと届かないため実質的に通知は期待できない。
export const LEAD_ENDPOINT = 'https://2wjtmoq5g2.execute-api.ap-northeast-1.amazonaws.com/lead';

/** リードの通知先(フォールバックの mailto 送信先) */
export const LEAD_MAIL_TO = 'info@cocowa-tech.com';
